import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { BroadcasterService } from '../broadcaster.service';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/first';

interface Toast {
  id: number;
  timeoutId: number | null;
  title?: string;
  message?: string;
  clickToClose?: any;
  timeToClose?: any;
  typeClass?: string;
}

@Component({
  selector: 'app-toasts-container',
  templateUrl: './toasts-container.component.html',
  styleUrls: ['./toasts-container.component.scss']
})
export class ToastsContainerComponent implements OnInit, OnDestroy {
  toasts = [];
  maxShown = 5;
  toastIndex = 0;
  private onExit: Subject<any> = new Subject();

  constructor(
    private broadcast: BroadcasterService,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    // subscribe to 'newToast'
    this.broadcast.on('newToast').subscribe(response => {
      this.createToast(response);
    });
  }

  createToast(options) {
    // check if there are more toasts than maxShown
    if (this.toasts.length >= this.maxShown) {
      // remove first toast
      this.toasts.shift();
    }
    // create the new toast
    let newToast: Toast = {
      id: this.toastIndex,
      timeoutId: null,
      title: options.title || '',
      message: options.message || '',
      clickToClose: options.clickToClose || false,
      timeToClose: options.timeToClose || 5000,
      typeClass: options.typeClass || 'info'
    };
    this.toastIndex++;
    // add automated close unless it is clickToClose
    if (!options.clickToClose) {
      newToast.timeoutId = this.createTimeout(newToast, newToast.timeToClose);
    }
    // add the toast into array
    this.toasts.push(newToast);
  }

  clickedToast(toast) {
    console.log('clicked ID: ' + toast.id);
  }

  enterToast(toast) {
    if (toast.timeoutId) {
      clearTimeout(toast.timeoutId);
      toast.timeoutId = null;
    }
  }

  leaveToast(toast) {
    if (!toast.clickToClose) {
      toast.timeoutId = this.createTimeout(toast, 3000);
    }
  }

  createTimeout(toast, toastLife?): any {
    let task: number;
    this.ngZone.runOutsideAngular(() => {
      task = setTimeout(() => {
        this.ngZone.run(() => this.removeToast(toast));
      }, (toastLife || 5000));
    });
    return task.toString();
  }

  removeToast(toast) {
    if (toast.timeoutId) {
      clearTimeout(toast.timeoutId);
      toast.timeoutId = null;
    }
    // using filter on the toast.id to remove this toast
    this.toasts = this.toasts.filter((t) => {
      return t.id !== toast.id;
    });
  }

  private _ngExit() {
    this.ngZone.onMicrotaskEmpty.first().subscribe(() => {
      this.onExit.next();
      this.onExit.complete();
    });
  }

  ngOnDestroy() {
    this._ngExit();
  }
}



// WEBPACK FOOTER //
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/services/toasts-container/toasts-container.component.ts